<template>
  <div class="d-flex align-items-start" @click="goBack()">
    <div class="header-button">
      <chevron-left-icon size="18"/>
    </div>
    <h1 class="page-title link">{{ title }}</h1>
  </div>

</template>

<script>

export default {
  name: 'BackArrow',
  props: {
    title: String,
    default: "Retour"
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.header-button-line {
  flex-direction: row;
}

.header-button {
  display: inline-block;
  background-color: var(--main-color);
  border-radius: var(--main-border-radius);
  color: var(--main-white);
  height: 24px;
  width: 24px;
  margin-right: 1em;
}

.header-button svg {
  height: 24px;
  width: 24px;
}

.header-button:hover {
  cursor: pointer;
  background-color: var(--main-color-hover);
  color: var(--main-white);
}

.link:hover {
  cursor: pointer;
  color: var(--main-color-hover);
}
</style>



// WEBPACK FOOTER //
// src/components/b122/BackArrow.vue